"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsForceShootSpecSchema = void 0;
const joi_1 = __importDefault(require("joi"));
/**
 * This is only a slice of SF data. If you need more, add more
 */
exports.JsForceShootSpecSchema = joi_1.default.object({
    Id: joi_1.default.string().required(),
    Name: joi_1.default.string().required(),
    Account__c: joi_1.default.string().required(),
    Active__c: joi_1.default.boolean().required(),
    Alternative_Submission_Required__c: joi_1.default.boolean().required(),
    Apply_Sky_Option_also_to_Windows__c: joi_1.default.boolean().required(),
    Briefing_Editing__c: joi_1.default.string().allow(null),
    Client_specific_examples_URL__c: joi_1.default.string().allow(null),
    Colour_Temperature__c: joi_1.default.string().allow(null),
    Custom_Model_Release__c: joi_1.default.string().allow(null),
    Custom_Product_Description__c: joi_1.default.string().allow(null),
    Custom_Property_Release__c: joi_1.default.string().allow(null),
    Default_Model_Release__c: joi_1.default.boolean().required(),
    Default_Property_Release__c: joi_1.default.boolean().required(),
    Description_for_Alternative_Submission__c: joi_1.default.string().allow(null),
    Editor_Enhanced_Guidelines_URL__c: joi_1.default.string().allow(null),
    Editors_briefing__c: joi_1.default.string().allow(null),
    Editors_Mood_Board_URL__c: joi_1.default.string().allow(null),
    Estimated_Editing_Time_h__c: joi_1.default.number().allow(null),
    Expected_Shoot_Duration_in_Hours__c: joi_1.default.number().allow(null),
    Exporting_Specifications__c: joi_1.default.string().allow(null),
    External_Name__c: joi_1.default.string().allow(null),
    Filename_Adjustment__c: joi_1.default.string().allow(null),
    General_Briefing_for_all_Photoshoots__c: joi_1.default.string().allow(null),
    Image_URL_visible_to_customer__c: joi_1.default.string().allow(null),
    Internal_use_Walk_Through_Video_Required__c: joi_1.default.boolean().required(),
    Last_Update_Editor_Guideline__c: joi_1.default.string().allow(null),
    Last_update_Photographer_Guideline__c: joi_1.default.string().allow(null),
    max_of_Photos_from_Photographer__c: joi_1.default.number().allow(null),
    Mood_Board_URL__c: joi_1.default.string().allow(null),
    of_Photos_Required_for_Submission__c: joi_1.default.number().allow(null),
    of_Photos_Required_from_Photographer__c: joi_1.default.number().allow(null),
    Password_for_Alternative_Submission__c: joi_1.default.string().allow(null),
    Real_Capacities_only__c: joi_1.default.boolean().required(),
    Required_Photographer_Equipment__c: joi_1.default.string().allow(null),
    Required_Photographer_Skills__c: joi_1.default.string().allow(null),
    Professional_Walk_Through_Video_Required__c: joi_1.default.boolean().required(),
    Release__c: joi_1.default.string().allow(null),
    Remove_Other__c: joi_1.default.string().allow(null),
    Renaming_info_for_editor__c: joi_1.default.string().allow(null),
    Shot_by_Owner__c: joi_1.default.boolean().required(),
    Sky_Replacement__c: joi_1.default.string().allow(null),
    Sort_Index__c: joi_1.default.number().allow(null),
    Specification_UUID__c: joi_1.default.string().uuid().required(),
    Style_Preference__c: joi_1.default.string().allow(null),
    URL_for_Alternative_File_Submission__c: joi_1.default.string().allow(null),
    Video_Briefing__c: joi_1.default.string().allow(null),
    Video_Required__c: joi_1.default.boolean().required(),
    Watermark_Anchor__c: joi_1.default.string().allow(null),
    Watermark_Description__c: joi_1.default.string().allow(null),
    Watermark_Example_URL__c: joi_1.default.string().allow(null),
    Watermark_File_URL__c: joi_1.default.string().allow(null),
    Watermark_Inset__c: joi_1.default.number().allow(null),
    Watermark_Inset_Vertikal__c: joi_1.default.number().allow(null),
    Watermark_Opacity_in__c: joi_1.default.number().allow(null),
    Watermark_Required__c: joi_1.default.boolean().required(),
    Watermark_Size__c: joi_1.default.number().allow(null)
})
    .unknown(true)
    .meta({ className: 'JsForceShootSpec' });
//# sourceMappingURL=JsForceShootSpecSchema.js.map